export const getList = (state) => state.list
export const getListExceptId = (state) => state.listExceptId
